import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Clock, MapPin, ArrowRight, Video } from 'lucide-react';
import { Button } from '../ui/button';
import { live, fmtTime } from '../../pages/live/liveApi';

/** Homepage Upcoming Classes — the four Coach Fern live sessions. Hidden automatically once the promo window ends (11 Oct 2026 5:30pm MYT). */
export const useLiveSessionCards = () => {
  const [sessions, setSessions] = useState([]);
  useEffect(() => {
    let alive = true;
    live.list().then((d) => { if (alive && d.promo_active) setSessions(d.sessions); }).catch(() => {});
    const t = setInterval(() => live.list().then((d) => { if (alive) setSessions(d.promo_active ? d.sessions : []); }).catch(() => {}), 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  return sessions;
};

export const LiveSessionCard = ({ s }) => {
  const navigate = useNavigate();
  return (
    <div className="group rounded-xl bg-white border-2 border-[#F9A8D4] hover:border-[#EC4899] hover:shadow-lg transition-all p-5 flex flex-col h-full" data-testid={`live-card-${s.slug}`}>
      <div className="flex items-start justify-between mb-3 gap-2">
        <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-[#FDF2F8] text-[#BE185D] text-[10px] font-black uppercase tracking-widest"><Video size={10} /> Live session</div>
        <span className="inline-flex items-center px-2 py-0.5 rounded bg-green-100 text-green-700 text-[10px] font-black uppercase tracking-widest">{s.state === 'live' ? 'Live now' : 'Free · booth or online'}</span>
      </div>
      <h3 className="text-lg font-black tracking-tight leading-tight mb-2 line-clamp-2 min-h-[3rem]">{s.title}</h3>
      <div className="space-y-1.5 text-sm text-slate-600 mb-4 flex-1">
        <div className="flex items-center gap-2"><Calendar size={14} className="flex-shrink-0 text-[#EC4899]" /><span>Sunday, 11 Oct 2026</span></div>
        <div className="flex items-center gap-2"><Clock size={14} className="flex-shrink-0 text-[#EC4899]" /><span>{fmtTime(s.start_time)}–{fmtTime(s.end_time)}</span></div>
        <div className="flex items-start gap-2"><MapPin size={14} className="flex-shrink-0 text-[#EC4899] mt-0.5" /><span className="line-clamp-1">LGRA Booth, WOW Plaza · Google Meet</span></div>
        <div className="text-[11px] font-bold uppercase tracking-widest text-slate-500 mt-2">{s.coach_name}</div>
      </div>
      <Button onClick={() => navigate(`/live-sessions/${s.slug}`)} className="w-full bg-[#EC4899] hover:bg-[#BE185D] text-white font-black uppercase tracking-widest text-xs h-10" data-testid={`live-card-${s.slug}-register`}>View & Register <ArrowRight size={14} className="ml-1" /></Button>
    </div>
  );
};
